import React from 'react';

import {Link} from 'react-router';

import {getTeamSignoffsURL} from 'app/urls';
import {printContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import {DateText, FixableHeader, FixableTable} from './utils';

import {ContentType, ReportResultSerializedType} from 'sweet-types';

interface Props {
  result: ReportResultSerializedType<{
    content_type: ContentType & ('procedure' | 'policy' | 'proceduregroup');
    timestamp: string;
    team: string;
    team_id: string;
    hashid: string;
    html_url: string;
    name: string;
    url: string;
    signed_count: number;
    unsigned_count: number;
  }>;
  timestampLabel?: string;
  memberLabel?: string;
}

export function RenderTeamSignoffSummaryDocuments({
  result,
  timestampLabel,
  memberLabel,
}: Props): JSX.Element {
  return (
    <FixableTable>
      <thead>
        <tr>
          <FixableHeader>{gt('Name')}</FixableHeader>
          <FixableHeader>{gt('Document type')}</FixableHeader>
          <FixableHeader>{timestampLabel ?? gt('Timestamp')}</FixableHeader>
          <FixableHeader>{memberLabel ?? gt('Team')}</FixableHeader>
          <FixableHeader textAlign="right">
            {gt('Unsigned Members')}
          </FixableHeader>
          <FixableHeader textAlign="right">
            {gt('Signed Members')}
          </FixableHeader>
        </tr>
      </thead>
      <tbody>
        {result.results.map((r, i) => (
          <tr key={i}>
            <td>
              <Link className="font-weight-bold" to={r.html_url}>
                {r['name']}
              </Link>
            </td>
            <td>{printContentType(r['content_type'])}</td>
            <td>
              <DateText>{r['timestamp']}</DateText>
            </td>
            <td>
              <div className="d-flex align-items-center">
                <Link to={getTeamSignoffsURL(r['team_id'])}>
                  <i className="fa fa-users mr-1" /> {r['team']}
                </Link>
              </div>
            </td>
            <td className="text-right">{r['unsigned_count']}</td>
            <td className="text-right">{r['signed_count']}</td>
          </tr>
        ))}
      </tbody>
    </FixableTable>
  );
}
